// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  useId: __t.u64().primaryKey().name("use_id"),
  recipeId: __t.u64().name("recipe_id"),
  workspaceId: __t.u64().name("workspace_id"),
  appliedAt: __t.i64().name("applied_at"),
});
